import React, { useState, useEffect } from 'react';
import { Instagram, Linkedin, Phone, Facebook, MessageCircle } from 'lucide-react';

const FloatingSocialBar = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const socialLinks = [
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/thisisaaryan__/',
      icon: Instagram,
      color: '#E4405F'
    },
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/share/18rojzLVTg/?mibextid=wwXIfr',
      icon: Facebook,
      color: '#1877F2'
    },
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/in/aryan-shivhare-profile/',
      icon: Linkedin,
      color: '#0A66C2'
    },
    {
      name: 'Threads',
      href: 'https://www.threads.com/@thisisaaryan__?xmt=AQG0RjWDsbf0LFDdkubXD_W8dduJ6Jb9iPxwfGye9jZCcyY',
      icon: MessageCircle,
      color: '#000000'
    },
    {
      name: 'WhatsApp',
      href: 'https://wa.me/491706684547',
      icon: Phone,
      color: '#25D366'
    }
  ];

  return (
    <div
      className={`fixed left-6 top-1/2 -translate-y-1/2 z-40 transition-all duration-300 ${
        isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
      }`}
    >
      <div className="flex flex-col gap-4 bg-black/80 backdrop-blur-sm border border-gold/20 rounded-full p-3">
        {socialLinks.map((social) => {
          const Icon = social.icon;
          return (
            <a
              key={social.name}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative w-12 h-12 flex items-center justify-center rounded-full bg-black border border-tertiary hover:border-gold transition-all duration-300 hover:scale-110"
              aria-label={social.name}
            >
              <Icon 
                className="w-5 h-5 text-secondary group-hover:text-gold transition-colors" 
                strokeWidth={1.5}
              />
              
              {/* Tooltip */}
              <span className="absolute left-full ml-4 px-3 py-2 bg-black border border-gold rounded-lg text-sm text-gold font-sans whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity">
                {social.name}
              </span>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default FloatingSocialBar;
